import React from 'react';

const ForumPage = () => {
  return (
    <div className="page-container">
      <h1>Community Forum</h1>
      <p>Engage with other creators, ask questions, share your work, and find collaborators in our interstellar community forum.</p>
    </div>
  );
};

export default ForumPage;